import { STAGES, LOCATIONS } from 'app/modules/ui/constants';

/*
Example state:

export default {
  isVisible: true,
  stage: 'ONBOARDING',
};

UI stage transitions:
ONBOARDING --(submit name and email)--> CHAT

*/

export default {
  autoShowWidget: false,
  isVisible: false, // displayed based on office hours or cookies
  minimizedAt: null,
  stage: null,
  isMinimized: true,
  compositionDraft: '',
  suppressedByRules: false,
  locationHistory: [LOCATIONS.HOME],
};
